(ns rlws.iot-cloud.frontend.uikit.editable-table
  (:require [reagent.core :as r]
            [potpuri.core :as potpuri]
            [rlws.iot-cloud.frontend.common :as common]))

(defn wrap-rows-in
  [sort-fn rows]
  (->> rows
       (sort-by sort-fn)
       (map-indexed #(assoc %2 :id %1))
       (vec)))

(defn action-link
  [{:keys [on-click class]} label]
  [:a {:href "#"
       :on-click (fn [event]
                   (.preventDefault event)
                   (on-click))
       :class (into #{"underline" "text-underline-offset-0.5"} class)}
   label])

(defn editable-table
  [{:keys [columns rows handle-change new-row sort-fn actions item-label
           additional-controls]
    :or {item-label "Row"}}]
  (let [sort-rows (fn [rows]
                    (vec (sort-by (if sort-fn (juxt sort-fn :id) :id) rows)))]
    (r/with-let [counter (r/atom (or (count rows) 0))
                 table-state (r/atom {:rows (or (wrap-rows-in sort-fn rows) [])})
                 _ (add-watch table-state
                              (random-uuid)
                              (fn [_ _ _ new]
                                (handle-change
                                 (->> (:rows new)
                                      (map #(dissoc % :id))
                                      sort-rows))))]
      (let [update-rows (fn [& args]
                          (apply swap! table-state update :rows args))
            add-row (fn []
                      (let [id (swap! counter inc)]
                        (update-rows (fn [rows]
                                       (let [new-row (when (fn? new-row)
                                                       (new-row rows))]
                                         (conj rows (assoc new-row :id id)))))))
            update-row (fn [id f & args]
                         (apply update-rows potpuri/update-first {:id id} f args))
            remove-row (fn [id]
                         (update-rows #(filterv (complement (potpuri/where-fn {:id id})) %)))
            actions (concat actions
                            [{:label (str "Remove " item-label)
                              :action-fn (fn [{:keys [remove-row row-value]}]
                                           (remove-row (:id row-value)))
                              :class #{:text-red-500}}])]
        [:<>
         [:div.uikit-table
          [:div.table-container
           [:table.table
            [:thead.table-header
             (into [:tr.table-header__tr]
                   (concat
                    (for [{:keys [key label type]} columns]
                      ^{:key key}
                      [:th.bg-gray-200
                       [:div.table-header__th-content
                        [:p.table-header__th-column label]]])
                    [[:th.bg-gray-200
                      [:div.table-header__th-content
                       [:p.table-header__th-column "Actions"]]]]))]
            (into [:tbody.table-body]
                  (for [{:keys [id] :as row} (:rows @table-state)
                        :let [update-row-key
                              (fn [key value]
                                (update-row id assoc key value))]]
                    ^{:key (str "row-" id)}
                    (into [:tr {:on-blur
                                (fn [event]
                                  (let [current-target (. event -currentTarget)
                                        related-target (. event -relatedTarget)]
                                    (when-not (. current-target contains related-target)
                                      (update-rows sort-rows))))}]
                          (concat
                           (for [{:keys [key type]} columns
                                 :let [input-type (case type
                                                    :integer :number
                                                    :float :number
                                                    :string :text
                                                    :text)]]
                             ^{:key key}
                             [:td
                              {:class #{"p-2"}}
                              [:input
                               {:class #{"p-1.5" "w-full"}
                                :type input-type
                                :data-datatype type
                                :value (or (get row key) "")
                                :on-change (fn [event]
                                             (let [target (. event -target)
                                                   type (. ^js/DOMStringMap (. target -dataset) -datatype)
                                                   coercer (case type
                                                             "integer" common/parse-int
                                                             "float" common/parse-float
                                                             identity)
                                                   value (coercer (. target -value))]
                                               (update-row-key key value)))}]])
                           [[:td
                             {:class #{"p-2" "w-1/5" "whitespace-nowrap"}}
                             (into [:div
                                    {:class #{"flex" "flew-row" "gap-2" "w-max"}}]
                                   (for [{:keys [action-fn label class]} actions]
                                     [action-link
                                      {:class (or class #{:text-blue-500})
                                       :on-click #(action-fn
                                                   {:update-row update-row
                                                    :remove-row remove-row
                                                    :add-row add-row
                                                    :row-value row})}
                                      label]))]]))))]]]
         (into [:div
                {:class #{"flex" "flex-row" "justify-start" "items-center"
                          "mt-3" "gap-2"}}
                [:button
                 {:class #{"btn" "bg-blue-500" "text-white" "flex"
                           "flex-row" "gap-2" "items-center"}
                  :type "button"
                  :on-click add-row}
                 [:span (str "Add " item-label)]
                 [:i.fas.fa-plus.fa-xs]]]
               (for [control additional-controls]
                 control))]))))
